<app-arcgis-map [pointsToShow]="pointsToShow" [layerList]="layerListSubject"></app-arcgis-map>
